(() => {
  const configElement = document.getElementById('uc-ordering-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const eligible = new Set(config.eligibleProducts.map(Number));
  const root = config.root;
  let pending;
  let failed = false;
  const managed = item => item.properties && item.properties._uc_free_bread === 'yes';
  const bread = item => Number(item.variant_id) === config.variant;
  const money = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  function subtotal(cart) {
    let reserve = 1;
    return cart.items.reduce((sum, item) => {
      if (!eligible.has(Number(item.product_id))) return sum;
      const excluded = bread(item) && reserve ? (reserve = 0, 1) : 0;
      return sum + (item.original_price * (item.quantity - excluded));
    }, 0);
  }
  async function request(path, data) {
    const response = await fetch(root + path, data ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) } : {});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Cart update failed');
    return result;
  }
  function paint(cart, message) {
    document.querySelectorAll('[data-uc-count]').forEach(element => { element.textContent = cart.item_count; });
    document.querySelectorAll('[data-uc-total]').forEach(element => { element.textContent = money(cart.total_price); });
    const node = document.getElementById('uc-offer-status');
    if (!node) return;
    const free = cart.items.some(item => bread(item) && item.line_level_discount_allocations.some(d => d.discount_application.title === config.title));
    node.textContent = message || (free ? config.messages.applied : subtotal(cart) > 2500 ? config.messages.qualified : config.messages.progress.replace('[amount]', money(Math.max(0, 2501 - subtotal(cart)))));
  }
  async function reconcile() {
    let cart = await request('cart.js');
    let changed = false;
    for (const item of cart.items.filter(managed)) {
      if (item.quantity !== 1) {
        await request('cart/change.js', { id: item.key, quantity: 1 });
        changed = true;
      }
    }
    if (changed) cart = await request('cart.js');
    const qualifies = subtotal(cart) > 2500;
    const gift = cart.items.find(managed);
    if (!qualifies && gift) {
      await request('cart/change.js', { id: gift.key, quantity: 0 });
      changed = true;
      cart = await request('cart.js');
    } else if (qualifies && !cart.items.some(bread) && sessionStorage.getItem('uc-gift-declined') !== 'yes') {
      await request('cart/add.js', { items: [{ id: config.variant, quantity: 1, properties: { _uc_free_bread: 'yes' } }] });
      changed = true;
      cart = await request('cart.js');
    }
    const addedGift = cart.items.find(managed);
    if (addedGift && addedGift.final_line_price !== 0) {
      await request('cart/change.js', { id: addedGift.key, quantity: 0 });
      cart = await request('cart.js');
      changed = true;
      sessionStorage.setItem('uc-gift-declined', 'yes');
      sessionStorage.setItem('uc-offer-message', config.messages.unavailable);
    }
    paint(cart, sessionStorage.getItem('uc-offer-message'));
    sessionStorage.removeItem('uc-offer-message');
    if (!cart.item_count) sessionStorage.removeItem('uc-gift-declined');
    failed = false;
    return changed;
  }
  function sync() {
    if (pending) return pending;
    pending = reconcile().catch(error => {
      failed = true;
      const node = document.getElementById('uc-offer-status');
      if (node) node.textContent = config.messages.error;
      throw error;
    }).finally(() => { pending = null; });
    return pending;
  }
  window.UpperCrustOffer = { sync };
  if (config.cartPage) {
    sync().then(changed => { if (changed) location.reload(); }).catch(() => {});
    document.addEventListener('uc:cart-updated', () => {
      document.querySelectorAll('[name="checkout"]').forEach(button => { delete button.dataset.ucReady; });
      sync().then(changed => { if (changed) location.reload(); }).catch(() => {});
    });
    document.addEventListener('click', async event => {
      const checkout = event.target.closest('[name="checkout"]');
      if (!checkout || checkout.dataset.ucReady === 'yes') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkout.disabled = true;
      try {
        await sync();
        if (!failed) {
          checkout.dataset.ucReady = 'yes';
          checkout.disabled = false;
          checkout.click();
        }
      } catch (_) { checkout.disabled = false; }
    }, true);
  } else {
    document.addEventListener('uc:cart-updated', () => { request('cart.js').then(cart => paint(cart)).catch(() => {}); });
  }
})();
